import type { QueryFunctionContext } from '@tanstack/react-query';

import { getAnalysisQueryKey } from '@/utilities/portfolio';

import { gql } from 'graphql-request';
import { requestWithAuth } from '@/utilities/graphQLClient';

type DiversificationTree = {
  type: string;
  weight: number;
  name?: string;
  symbol?: string;
  sectors?: DiversificationTree[];
  primaryIndustries?: DiversificationTree[];
  holdings?: DiversificationTree[];
};

export interface PortfolioFragmentType {
  diversification?: DiversificationTree;
}

interface QueryResponse {
  errors?: Error[];
  Portfolio?: PortfolioFragmentType;
}

type QueryContext = QueryFunctionContext<
  ReturnType<typeof getAnalysisQueryKey>
>;

export const queryFn = async ({
  queryKey: [_key, portfolioId],
}: QueryContext) => {
  const { Portfolio, errors } = await requestWithAuth<QueryResponse>(
    gql`
      query getPortfolioDivesification($portfolioId: String!) {
        Portfolio(id: $portfolioId) {
          diversification
        }
      }
    `,
    { portfolioId }
  );

  if (errors?.length) {
    const [firstError] = errors;
    throw new Error(firstError.message);
  }

  return Portfolio;
};
